
import { browser } from '$app/environment'
import { apiFetchJson } from '$lib/proxy/apiProxy'
import type { SubscriptionPlanFeature } from '$lib/types/subscription_types'




// const store = writable([] as SubscriptionTableInfo[])
// export { store as subscription_table_info_store }
let subscriptionPlanFeatures: SubscriptionPlanFeature[] = []


let promiseFetch: Promise<SubscriptionPlanFeature[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

export const InitSubscriptionPlanFeatures = async (pFetch = fetch, force = false) => {
	// if SSR just return the promise data
	if (!browser) return fetchData(pFetch)

	if (!force && state === 'ready') return
	if (!force && state === 'reading') {
		await promiseFetch
		return true
	}

	promiseFetch = fetchData(pFetch)
	await promiseFetch
	return true
}

const fetchData = async (pFetch = fetch) => {
	if (browser) state = 'reading'

	const jsonData = await apiFetchJson(pFetch, 'get', '/subscription/planfeatures')
	if (!jsonData || jsonData.error) {
		if (browser) state = 'pending'
		return []
	}

	// const data = parseServer(jsonData)
	const data = jsonData
	if (browser) {
		subscriptionPlanFeatures = data
		// store.set(data)
		state = 'ready'
	}

	return data
}


export async function getSubscriptionPlanFeatures() {

	await InitSubscriptionPlanFeatures()
	return subscriptionPlanFeatures

}